import {Response} from "@core/model";
import {SnackbarMessage} from "@core/model/SnackbarMessage";
import {Any} from "@core/types";
import {
  PayloadAction,
  createSlice,
  isFulfilled,
  isRejectedWithValue,
} from "@reduxjs/toolkit";

type SnackbarState = {
  message: SnackbarMessage | null;
};

const initialState: SnackbarState = {
  message: null,
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState: initialState,
  reducers: {
    showMessage: (
      state: SnackbarState,
      action: PayloadAction<SnackbarMessage>,
    ) => {
      state.message = action.payload;
    },
    closeMessage: (state: SnackbarState) => {
      state.message = null;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(isFulfilled, (state, action) => {
        const endpoint = (action.meta.arg as any).endpointName;
        const skip = [
          "login",
          "logout",
          "uploadFile",
          "deleteFiles",
          "sendChatMessage",
        ].includes(endpoint);
        if (!skip && action.type.indexOf("executeMutation") > 0) {
          state.message = {text: "Operation succesful", severity: "success"};
        }
      })
      .addMatcher(isRejectedWithValue, (state, action) => {
        const endpoint = (action.meta.arg as any).endpointName;
        // l'errore della chat resta nel pannello
        if (
          endpoint === "sendChatMessage" ||
          endpoint === "fetchChatStatus" ||
          endpoint === "fetchChatSuggestions" ||
          endpoint === "fetchChatProviderModels" ||
          endpoint === "reindexChatKnowledge"
        ) {
          return;
        }
        const response = (action?.payload as any)?.data as Response<Any>;
        if (response) {
          const code = response.code ?? 0;
          // 1508 lo mostra la pagina o il pannello, non la snackbar
          if (code === 1508) {
            return;
          }
          const message = response.message?.trim();
          state.message = {
            text: code === 1507 && message ? message : `error.${code}`,
            severity: "error",
          };
        } else {
          state.message = {text: "error.0", severity: "error"};
        }
      });
  },
});

export const {showMessage, closeMessage} = snackbarSlice.actions;

export default snackbarSlice.reducer;
